<div id="dashboard-analytics" class="page-layout blank">
    <div class="content">

        <div class="left mr-lg-32">

            <div class="pb-24 font-size-18 font-weight-300">
                {{'How are your users buying over time?'|translate}}
            </div>

            <div class="pb-24 font-size-18 font-weight-300">
                <button (click)="today()" mat-raised-button class="mr-8" color="accent">{{'Today'|translate}}</button>
                <button (click)="yesterday()" mat-raised-button class="mr-8"
                        color="accent">{{'Yesterday'|translate}}</button>
                <button (click)="lastWeek()" mat-raised-button class="mr-8"
                        color="accent">{{'Last week'|translate}}</button>
                <button (click)="lastMonth()" mat-raised-button class="mr-8"
                        color="accent">{{'Last month'|translate}}</button>
            </div>

            <div fxLayout="column" fxLayoutAlign="start"
                 fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <!-- Widget 2 -->
                <div class="widget" fxFlex="100" fxFlex.gt-sm="33">

                    <div class="fuse-card auto-width mb-32" [ngClass.gt-sm]="'mb-0 mr-32'">

                        <div class="p-16 pb-0" fxLayout="row wrap" fxLayoutAlign="start end">
                            <div class="pr-16">
                                <div class="h3 secondary-text">{{'Date range'|translate}}</div>
                                <div class="font-size-40 font-weight-300 line-height-1 mt-8">
                                    <form [formGroup]="dateRange">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Start date</mat-label>
                                            <input matInput formControlName="start" [matDatepicker]="picker"
                                                   (dateChange)="reloadStats($event)">
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                        <mat-form-field appearance="fill">
                                            <mat-label>End date</mat-label>
                                            <input matInput formControlName="end" [matDatepicker]="picker2"
                                                   (dateChange)="reloadStats($event)">
                                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                            <mat-datepicker #picker2></mat-datepicker>
                                        </mat-form-field>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Widget 2 -->
                <div class="widget" fxFlex="100" fxFlex.gt-sm="33">

                    <div class="fuse-card auto-width mb-32" [ngClass.gt-sm]="'mb-0 mr-32'">

                        <div class="p-16 pb-0" fxLayout="row wrap" fxLayoutAlign="start end">

                            <div class="pr-16">
                                <div class="h4 secondary-text">
                                    {{'Selling'|translate}}
                                    <app-info
                                            message="Total value of sale (traditional, internet shop and mobile app)."></app-info>
                                </div>
                                <div class="font-size-36 font-weight-300 line-height-1 mt-8">
                                    {{totalValue|currency:' '}} PLN
                                </div>
                            </div>

                            <!--                            <div class="py-4 font-size-16" fxLayout="row" fxLayoutAlign="start center">-->
                            <!--                                <div fxFlex="row" fxLayoutAlign="start center" class="green-fg"-->
                            <!--                                     *ngIf="widgets.widget2.conversion.ofTarget > 0">-->
                            <!--                                    <mat-icon class="green-fg mr-4">trending_up</mat-icon>-->
                            <!--                                    <span>{{widgets.widget2.conversion.ofTarget}}%</span>-->
                            <!--                                </div>-->
                            <!--                                <div fxFlex="row" fxLayoutAlign="start center" class="red-fg"-->
                            <!--                                     *ngIf="widgets.widget2.conversion.ofTarget < 0">-->
                            <!--                                    <mat-icon class="red-fg mr-4">trending_down</mat-icon>-->
                            <!--                                    <span>{{widgets.widget2.conversion.ofTarget}}%</span>-->
                            <!--                                </div>-->
                            <!--                                <div class="ml-4 text-nowrap">of target</div>-->
                            <!--                            </div>-->

                        </div>

                        <div class="h-96 w-100-p">
                            <canvas baseChart
                                    [datasets]="totalValueChart.datasets"
                                    [labels]="totalValueChart.labels"
                                    [colors]="chartColors"
                                    [options]="totalValueChart.options"
                                    [chartType]="totalValueChart.chartType">
                            </canvas>
                        </div>

                    </div>

                </div>
                <!-- / Widget 2 -->

                <!-- Widget 4 -->
                <div class="widget" fxFlex="100" fxFlex.gt-sm="34">

                    <div class="fuse-card auto-width mb-32" [ngClass.gt-sm]="'mb-0 mr-32'">

                        <div class="p-16 pb-0" fxLayout="row wrap" fxLayoutAlign="start center">

                            <div class="pr-16">
                                <div class="h3 secondary-text">
                                    {{'Quantity'|translate}}
                                    <app-info message="Total quantity of sold products and vouchers."></app-info>
                                </div>
                                <div class="font-size-36 font-weight-300 line-height-1 mt-8">
                                    {{ totalQuantity }} {{'PCS'|translate}}
                                </div>
                            </div>

                        </div>

                        <div class="h-96 w-100-p">
                            <canvas baseChart
                                    [datasets]="totalQuantityChart.datasets"
                                    [labels]="totalQuantityChart.labels"
                                    [colors]="totalQuantityChart.chartColor"
                                    [options]="totalQuantityChart.options"
                                    [chartType]="totalQuantityChart.chartType">
                            </canvas>
                        </div>

                    </div>

                </div>
                <!-- / Widget 4 -->


            </div>

            <div fxLayout="column" fxLayoutAlign="start"
                 fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <!-- Widget 2 -->
                <div class="widget" fxFlex="100">
                    <!-- Widget 5 -->
                    <div class="pb-24 font-size-18 font-weight-300">
                        {{ 'Selling data'|translate }}
                        <app-info
                                message="List displays sold products and vouchers with prices and quantities."></app-info>
                    </div>

                    <div class="fuse-card content-card auto-width">

                        <div id="ngx-datatable" class="page-layout simple fullwidth docs">
                            <div class=" p-24 datatable-content">

                                <ngx-datatable
                                        class="material datatable-content"
                                        style="width: 100%;"
                                        [rows]="rows"
                                        [loadingIndicator]="loadingIndicator"
                                        [columnMode]="'force'"
                                        [headerHeight]="48"
                                        [footerHeight]="66"
                                        [rowHeight]="'auto'"
                                        [scrollbarH]="true"
                                        [reorderable]="reorderable"
                                        [selectionType]="'checkbox'"
                                        [limit]="15">


                                    <ngx-datatable-column name="{{'Name'|translate}}"
                                                          prop="referenceName" minWidth="280"></ngx-datatable-column>

                                    <ngx-datatable-column name="{{'Net value'|translate}}"
                                                          prop="netValue" maxWidth="120">
                                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                            {{row.netValue|currency:' '}}
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column name="{{'Gross value'|translate}}"
                                                          prop="grossValue" maxWidth="120">
                                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                            {{row.grossValue|currency:' '}}
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column name="{{'Quantity' | translate}}" prop="quantity" maxWidth="50">
                                    </ngx-datatable-column>
                                    <ngx-datatable-column name="{{'Worker'|translate}}">
                                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                            {{row.worker.firstName}} {{row.worker.lastName}} ({{row.worker.username}})
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column name="{{'Created at' | translate}}" prop="invoiceNumber">
                                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                                            {{row.createdAt | date:'dd.MM.yyyy H:mm:ss':'UTC'}}
                                        </ng-template>
                                    </ngx-datatable-column>
                                </ngx-datatable>
                            </div>
                        </div>

                    </div>
                    <!-- / Widget 5 -->

                </div>
            </div>

            <div fxLayout="column" fxLayoutAlign="start"
                 fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <div class="widget pt-24" fxFlex="100" style="overflow-x: scroll;">
                    <div class="pb-24 font-size-18 font-weight-300">
                        {{'What are your the best sellers?'|translate}}
                    </div>

                    <div class="fuse-card content-card auto-width">

                        <div class="p-16" fxLayout="row" fxLayoutAlign="space-between center">
                            <div class="h1 pr-16">
                                {{ 'The best sellers'|translate }}
                                <app-info message="List displays selling by user."></app-info>
                            </div>
                        </div>

                        <table class="simple clickable">
                            <thead>
                            <tr>
                                <th></th>
                                <th class="text-right" colspan="2"
                                    style="text-align: center;">{{'Products'|translate}}</th>
                                <th class="text-right" colspan="2"
                                    style="text-align: center;">{{'Vouchers'|translate}}</th>
                                <th class="text-right" colspan="2"
                                    style="text-align: center;">{{'Total'|translate}}</th>
                            </tr>
                            <tr>
                                <th>{{'Name'|translate}}</th>
                                <th class="text-right">{{'Net value'|translate}}</th>
                                <th class="text-right">{{'Gross value'|translate}}</th>
                                <th class="text-right">{{'Net value'|translate}}</th>
                                <th class="text-right">{{'Gross value'|translate}}</th>
                                <th class="text-right">{{'Net value'|translate}}</th>
                                <th class="text-right">{{'Gross value'|translate}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let row of topSellersSummaryData">
                                <td>{{row.firstName}} {{row.lastName}} ({{row.username}})</td>
                                <td class="text-right">{{row.productsNetValue|currency:' '}}</td>
                                <td class="text-right">{{row.productsGrossValue|currency:' '}}</td>
                                <td class="text-right">{{row.vouchersNetValue|currency:' '}}</td>
                                <td class="text-right">{{row.vouchersGrossValue|currency:' '}}</td>
                                <td class="text-right">{{row.netValue|currency:' '}}</td>
                                <td class="text-right">{{row.grossValue|currency:' '}}</td>
                            </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>


            <div fxLayout="column" fxLayoutAlign="start"
                 fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <div class="widget pt-0" fxFlex="100" style="overflow-x: scroll;">

                    <!-- Widget 5 -->
                    <div class="pt-24 pb-24 font-size-18 font-weight-300">
                        {{ 'Selling data by seller and day'|translate }}
                        <app-info message="List displays sold data by user, products and vouchers."></app-info>
                    </div>

                    <div class="fuse-card content-card auto-width">

                        <div id="ngx-datatable-2" class="page-layout simple fullwidth" style="overflow: scroll;">
                            <div class="content p-24 datatable-content">
                                <table class="simple clickable">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th colspan="3" style="text-align: center;">{{'Products'|translate}}</th>
                                        <th colspan="3" style="text-align: center;">{{'Vouchers'|translate}}</th>
                                        <th colspan="2" style="text-align: center;">{{'Total'|translate}}</th>
                                    </tr>
                                    <tr>
                                        <th>{{'Name'|translate}}</th>
                                        <th>{{'Date'|translate}}</th>
                                        <th class="text-right">{{'Net value'|translate}}</th>
                                        <th class="text-right">{{'Gross value'|translate}}</th>
                                        <th class="text-right">{{'Quantity'|translate}}</th>
                                        <th class="text-right">{{'Net value'|translate}}</th>
                                        <th class="text-right">{{'Gross value'|translate}}</th>
                                        <th class="text-right">{{'Quantity'|translate}}</th>
                                        <th class="text-right">{{'Net value'|translate}}</th>
                                        <th class="text-right">{{'Gross value'|translate}}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let row of topSellersData">
                                        <td>{{row.firstName}} {{row.lastName}} ({{row.username}})</td>
                                        <td>{{row.day}}-{{row.month}}-{{row.year}}</td>
                                        <td class="text-right">{{row.productsNetValue|currency:' '}}</td>
                                        <td class="text-right">{{row.productsGrossValue|currency:' '}}</td>
                                        <td class="text-right">{{row.productsQuantity}}</td>
                                        <td class="text-right">{{row.vouchersNetValue|currency:' '}}</td>
                                        <td class="text-right">{{row.vouchersGrossValue|currency:' '}}</td>
                                        <td class="text-right">{{row.vouchersQuantity}}</td>
                                        <td class="text-right">{{row.netValue|currency:' '}}</td>
                                        <td class="text-right">{{row.grossValue|currency:' '}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                    <!-- / Widget 5 -->

                </div>
            </div>

        </div>

        <div class="right">

            <div fxLayout="row wrap" fxLayout.gt-md="column">

                <!-- Widget 9 -->
                <div class="mb-48" [ngClass.lt-lg]="'mr-32'" [ngClass.xs]="'mr-0'" *ngIf="topProducts.length>0">

                    <div class="pb-24 font-size-18 font-weight-300" [ngClass.lt-lg]="'pt-0'">
                        {{'What are your top products?'|translate}}
                    </div>

                    <div class="fuse-card">

                        <div class="p-16" fxLayout="row" fxLayoutAlign="space-between center">
                            <div class="h2 pr-16">
                                {{ 'Top products'|translate }}
                                <app-info message="Best selling products by selected range of date."></app-info>
                            </div>
                        </div>

                        <table class="simple clickable">
                            <thead>
                            <tr>
                                <th>{{'Name'|translate}}</th>
                                <th class="text-right">{{'Quantity'|translate}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let row of topProducts">
                                <td>{{row.name}}</td>
                                <td class="text-right">{{row.productsQuantity}}</td>
                            </tr>
                            </tbody>
                        </table>

                    </div>

                </div>
                <!-- / widget 9 -->


                <!-- Widget 10 -->
                <div class="mb-48" [ngClass.lt-lg]="'mr-32'" [ngClass.xs]="'mr-0'" *ngIf="topVouchers.length>0">

                    <div class="pb-24 font-size-18 font-weight-300" [ngClass.lt-lg]="'pt-0'">
                        {{'What are your top vouchers?'|translate}}
                    </div>

                    <div class="fuse-card">

                        <div class="p-16" fxLayout="row" fxLayoutAlign="space-between center">
                            <div class="h2 pr-16">
                                {{ 'Top vouchers'|translate }}
                                <app-info message="Best selling vouchers by selected range of date."></app-info>
                            </div>
                        </div>

                        <table class="simple clickable">
                            <thead>
                            <tr>
                                <th>{{'Name'|translate}}</th>
                                <th class="text-right">{{'Quantity'|translate}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let row of topVouchers">
                                <td>{{row.name}}</td>
                                <td class="text-right">{{row.vouchersQuantity}}</td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="card-divider full-width"></div>

                        <!--                        <div class="p-8 pt-16" fxLayout="row" fxLayoutAlign="start center">-->
                        <!--                            <button mat-button color="accent">GO TO CAMPAIGNS</button>-->
                        <!--                        </div>-->

                    </div>

                </div>
                <!-- / widget 10 -->

                <!-- Widget 11 -->
                <div class="mb-48" [ngClass.lt-lg]="'mr-32'" [ngClass.xs]="'mr-0'"
                     *ngIf="paymentMethodsSummaryData.items.length>0">

                    <div class="pb-24 font-size-18 font-weight-300" [ngClass.lt-lg]="'pt-0'">
                        {{'Payment methods summary'|translate}}
                    </div>

                    <div class="fuse-card">

                        <div class="p-16" fxLayout="row" fxLayoutAlign="space-between center">
                            <div class="h2 pr-16">
                                {{ 'Payment methods'|translate }}
                                <app-info
                                        message="The best popular payment methods by selected range of date."></app-info>
                            </div>
                        </div>

                        <table class="simple clickable">
                            <thead>
                            <tr>
                                <th>{{'Name'|translate}}</th>
                                <th class="text-right">{{'Price net'|translate}}</th>
                                <th class="text-right">{{'Price gross'|translate}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let row of paymentMethodsSummaryData.items">
                                <td>{{row.paymentMethod}}</td>
                                <td class="text-right">{{row.netValue}}</td>
                                <td class="text-right">{{row.grossValue}}</td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="card-divider full-width"></div>

                    </div>

                </div>
                <!-- / widget 11 -->

                <!-- Widget 11 -->
                <div class="mb-48" [ngClass.lt-lg]="'mr-32'" [ngClass.xs]="'mr-0'" *ngIf="visitorsSummaryData.length>0">

                    <div class="pb-24 font-size-18 font-weight-300" [ngClass.lt-lg]="'pt-0'">
                        {{'Visitors summary'|translate}}
                    </div>

                    <div class="fuse-card">

                        <div class="p-16" fxLayout="row" fxLayoutAlign="space-between center">
                            <div class="h2 pr-16">
                                {{ 'Visitors per day'|translate }}
                                <app-info message="Visitors quantity by selected range of date."></app-info>
                            </div>
                        </div>

                        <table class="simple clickable">
                            <thead>
                            <tr>
                                <th>{{'Date'|translate}}</th>
                                <th class="text-right">{{'Visits'|translate}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let row of visitorsSummaryData">
                                <td>{{row.day}}.{{row.month}}.{{row.year}}</td>
                                <td class="text-right">{{row.visits}}</td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="card-divider full-width"></div>

                    </div>

                </div>
                <!-- / widget 11 -->

            </div>

        </div>

    </div>

</div>
